<div
    class="tw-flex tw-gap-3 tw-overflow-hidden tw-mb-3 tw-rounded-lg tw-bg-white tw-p-4 tw-shadow-sm tw-ring-1 tw-ring-gray-200 last:tw-mb-0"
>
    <div class="tw-flex-1">
        <b class="tw-block tw-text-base tw-font-semibold tw-text-gray-900">{{ title }}</b>
        <p class="tw-m-0 tw-mt-2 tw-leading-6 tw-text-gray-700">{{ content }}</p>
    </div>
</div>
